<template>
  <footer class="footer">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img class="img" src="../images/logo.svg" />
        </router-link>
        <div class="desc">
          {{ settings("requisites") }}
        </div>
      </div>

      <div class="right">
        <div class="nav">
          <router-link
            v-for="{ title, id } in staticPages"
            :key="id"
            :to="generatePathWithParams(title, id)"
            class="title tinyest"
          >
            {{ title }}
          </router-link>
        </div>
        <div class="footer-contact">
          <div class="email" v-if="settings('support_email')">
            <div class="desc small">{{ $t("Contact us") }}:</div>
            <a
              class="desc small link"
              @click.prevent="copyToClipboard(settings('support_email'))"
              style="cursor: pointer"
            >
              {{ settings("support_email") }}
            </a>
          </div>
          <div class="socials">
            <a
              v-for="link in $parent.socialLinks"
              :key="link.image"
              :href="link.link"
              target="_blank"
              class="item"
            >
              <img :src="link.img" :alt="link.link" class="img" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="left">
        <div class="desc">
          {{ settings("copyright") }}
        </div>
      </div>
      <div class="right">
        <div class="methods">
          <img class="img visa" src="../images/methods/visa.svg" />
          <img class="img mc" src="../images/methods/mc.svg" />
          <img class="img ds" src="../images/methods/3ds.svg" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  props: [],
  data: function () {
    return {};
  },
  methods: {
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.success(this.$t("Email copied to clipboard"));
      } catch (err) {
        this.$toast.error(this.$t("Failed to copy"));
      }
    },
    convertTitle(title) {
      if (typeof title === "string") {
        return title.replace(/ /g, "_").toLowerCase();
      }
      return title;
    },
    generatePathWithParams(title, id) {
      const convertedTitle = this.convertTitle(title);
      return {
        name: "TextPage",
        params: { title: convertedTitle, id: id },
      };
    },
  },
  mounted() {},
  computed: {
    ...mapGetters("app", ["staticPages", "settings"]),
  },
};
</script>
